module.exports =
{

  _init: function ()
  {
    APPLICATION._APPLICATION.processLinks("#developments", "PackageDevelopments", "developments")
  }

}